import { Link, useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Logout from "@mui/icons-material/Logout";
import MoreIcon from "@mui/icons-material/MoreVert";
import NotificationBell from "../notification/NotificationBell";
import { useAuth } from "../../../context/AuthContext";

import YuduLogo from "../../../assets/Yudu-logo.png";
import { Avatar, Button, Grid2, ListItemIcon, ListItemText, Stack, Typography } from "@mui/material";
import ThemeSwitcher from "../theme-switcher/ThemeSwitcher";
import { MenuOpen } from "@mui/icons-material";
import useDrawerStore from "../../../setup/store/useDrawerStore";
import { useIsDesktopLayout } from "../../../hooks/useIsDesktopLayout";
import { useAuthentication } from "../../services/AuthenticationService";
import { stringAvatar } from "@utils/helper";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import { useOrgBranding } from "../../../hooks/useOrgBranding";

const TopNavigation: React.FC = () => {

  const isMediumScreen = useIsDesktopLayout();

  const navigate = useNavigate();
  const { toggle } = useDrawerStore();
  const { profile: user, baseRole } = useAuth();
  const { logout } = useAuthentication();
  const { logoUrl, orgName } = useOrgBranding();

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, background: (theme) => theme.palette.background.paper }}
      >
        <Toolbar sx={{ px: 0 }}>
          {!isMediumScreen &&
            <IconButton size='large' onClick={() => toggle()}>
              <MenuOpen />
            </IconButton>
          }
          {/* Smaller logo on mobile so the hamburger + controls fit ONE row.
              The full-width logo (~275px) otherwise squeezes the controls group
              until it wraps to a 2nd row, making the AppBar 96px tall while the
              content spacer stays 56px → the page title hid under the header.
              When the org has saved a custom logo (logoUrl) we render that;
              otherwise fall back to the default HG asset. */}
          {/* Fit-the-bar sizing (not a fixed height): the AppBar height is
              fixed (its content spacer is a plain <Toolbar/>), so the logo must
              stay under the bar to avoid pushing content underneath. maxHeight
              is the largest that fits with breathing room (56 in the 64px
              desktop bar / 40 in the 56px mobile bar) — up ~1.4x from 40/28 for
              square emblems (EduNova/AGG). maxWidth keeps HG's 7:1 wordmark at
              its previous size (280x40 desktop / 196x28 mobile), so it neither
              overflows nor re-triggers the mobile two-row wrap. */}
          <img
            src={logoUrl ?? YuduLogo}
            alt={orgName}
            style={{
              maxHeight: isMediumScreen ? 56 : 40,
              maxWidth: isMediumScreen ? 280 : 196,
              width: "auto",
              height: "auto",
            }}
          />


          <Grid2 container sx={{ ml: 'auto', flexWrap: 'nowrap', flexShrink: 0, alignItems: 'center' }}>
            <ThemeSwitcher />

            {isMediumScreen && (
              <>
                <NotificationBell />

                <PopupState variant="popover">
                  {(popupState) => (
                    <>
                      <Button size="small" variant="text" color="inherit" {...bindTrigger(popupState)}>
                        <Grid2 container spacing={1.5} justifyContent="center" alignItems="center">
                          <Avatar src={user?.avatar_url ?? undefined} {...stringAvatar(user?.first_name && user?.last_name ? `${user.first_name} ${user.last_name}` : `${user?.base_role}`)} sx={{ width: 34, height: 34 }} />
                          <Stack spacing={0} sx={{ textTransform: 'capitalize' }} alignItems="start">
                            <Typography sx={{ color: theme => theme.palette.text.primary }} lineHeight="140%">{user?.first_name && user?.last_name ? `${user.first_name} ${user.last_name}` : user?.base_role}</Typography>
                            <Typography sx={{ color: theme => theme.palette.text.primary }} lineHeight="140%" variant="weak" fontSize={11}>{user?.base_role}</Typography>
                          </Stack>
                        </Grid2>
                      </Button>
                      <Menu
                        {...bindMenu(popupState)}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                      >
                        <MenuItem
                          component={Link}
                          to={`/${baseRole}/profile`}
                          onClick={popupState.close}
                        >
                          Profile
                        </MenuItem>
                        <MenuItem onClick={logout}>Sign Out</MenuItem>
                      </Menu>
                    </>
                  )}
                </PopupState>
              </>
            )}

            {!isMediumScreen && (
              <PopupState variant="popover" >
                {(popupState) => (
                  <>
                    <IconButton
                      size="large"
                      // onClick={handleMobileMenuOpen}
                      {...bindTrigger(popupState)}
                    >
                      <MoreIcon />
                    </IconButton>

                    <Menu
                      {...bindMenu(popupState)}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    >
                      <MenuItem
                        onClick={() => { popupState.close(); navigate("/notifications"); }}
                      >
                        <ListItemIcon>
                          <NotificationsIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Notifications</ListItemText>
                      </MenuItem>
                      <MenuItem 
                        onClick={popupState.close}
                        component={Link} to={`/${baseRole}/profile`}
                      >
                        <ListItemIcon>
                          <AccountCircle fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Profile</ListItemText>
                      </MenuItem>
                      <MenuItem
                        onClick={() => { popupState.close(); logout(); }}
                      >
                        <ListItemIcon>
                          <Logout fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Logout</ListItemText>
                      </MenuItem>
                    </Menu>
                  </>
                )}
              </PopupState>
            )}

          </Grid2>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default TopNavigation;
